import { ellipsis } from "../utils";

export function truncateEnd(anchorText, truncateLen, ellipsisChars) {
    return ellipsis(anchorText, truncateLen, ellipsisChars);
}

//# sourceMappingURL=truncate-end.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/autolinker/dist/es2015/truncate/truncate-end.js
// module id = 958
// module chunks = 0